import React, {forwardRef, useState} from "react";

import EventNotes from "../EventNotes";
import ChangeQuarterAndTime from "../ChangeQuarterAndTime";
import Header from "../Header";
import ConfirmButton from "../ConfirmButton";
import Submit from "./../HandleSubmit"

const handleSubmit = (options) => {
    const {eventDetailsToEdit: event, matchData, matchId, setMatchData} = options
    const eventQuarter = event?.quarterSelected;
    let quarter = '';
    if(eventQuarter) {
        switch (eventQuarter) {
            case 'Q1':
                quarter = 1;
                break;
            case 'Q2':
                quarter = 2;
                break;
            case 'Q3':
                quarter = 3;
                break;
            case 'Q4':
                quarter = 4;
                break;
        }
    }

    const psEvent = {
        minute: Math.ceil(event.timestamp/60),
        quarter,
        additionalData: event.eventNotes,
        isChanged: true
    }

    const update = {
        matchPosts: matchData.matchPosts.map(post => {
            if(event.id === post.id) {
                return {
                    ...post,
                    ...psEvent,
                }
            }
            return post;
        })
    }

    Submit(matchId, matchData, update, setMatchData);
}

const EditPenaltyEvent = forwardRef(
    (
        {
            setIsEditModalOpen,
            sides,
            eventDetailsToEdit,
            setEventDetailsToEdit,
            EVENT_TYPES,
            PS_TYPES,
            setEventsToShow,
            setSides,
            goals,
            setGoals,
            isEditing,
            setIsEditing,
            matchData,
            matchId,
            setMatchData
        },
        ref
    ) => {

        const [confirmButton, setConfirmButton] = useState(false);

        return (
            <div
                ref={ref}
                style={{
                    backgroundColor: "#E5E5E5",
                }}
            >
                <Header
                    eventDetails={eventDetailsToEdit}
                    setEventDetails={setEventDetailsToEdit}
                    setModalOpen={setIsEditModalOpen}
                    isEditing={isEditing}
                    setEventsToShow={setEventsToShow}
                    matchData={matchData}
                    matchId={matchId}
                    setMatchData={setMatchData}
                />
                <ChangeQuarterAndTime
                    eventDetails={eventDetailsToEdit}
                    setEventDetails={setEventDetailsToEdit}
                    matchId={matchId}
                    setMatchData={setMatchData}
                    matchData={matchData}
                    setConfirmButton={setConfirmButton}
                    setEventsToShow={setEventsToShow}
                />
                <EventNotes
                    textAreaValue={eventDetailsToEdit?.eventNotes}
                    showConfirmCancelButtons={!!eventDetailsToEdit?.eventNotes?.length}
                    confirmButtonAction={() => {
                    }}
                    cancelButtonAction={() => {
                        setEventDetailsToEdit((data) => ({
                            ...data,
                            eventNotes: "",
                        }));
                    }}
                    onChange={(e) => {
                        setEventDetailsToEdit((data) => ({
                            ...data,
                            eventNotes: e.target.value,
                        }));
                    }}
                />

                <ConfirmButton
                    action={() => {
                        handleSubmit({eventDetailsToEdit, matchData, matchId, setMatchData});
                        setEventsToShow((data) => {
                            return [
                                ...data?.map((item) => {
                                    if (item?.id === eventDetailsToEdit?.id) {
                                        return eventDetailsToEdit;
                                    } else return item;
                                }),
                            ];
                        });
                        setIsEditing(false);
                        setIsEditModalOpen(false);
                    }}
                />

            </div>
        );
    }
);

export default EditPenaltyEvent;
